import React from "react";
import { MapPin, Phone, Mail } from "lucide-react";
import { Link } from "react-router-dom";
import logo from "../../img/logo-yellow.png";

export default function Footer() {
  return (
    <footer className="bg-[#0d1442] text-white py-16">
      <div className="max-w-7xl mx-auto px-6">
        {/* Main grid */}
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          
          {/* Logo & About */}
          <div className="md:col-span-2">
            <img
              src={logo}
              alt="Jasmine Enterprises"
              className="h-24 w-auto mb-6"
            />

            <p className="text-white/60 leading-relaxed max-w-md text-sm">
              A comprehensive engineering solutions partner, delivering
              castings, precision parts, and electrical power transmission
              components across multiple industries.
            </p>

            <p className="text-[#f9d71c] mt-4 font-medium italic text-sm">
              “Strength In Every Casting. Precision In Every Fitting.”
            </p>
          </div>

          {/* Products */}
          <div className="md:justify-self-end text-left">
            <h4 className="font-semibold mb-4">Products</h4>
            <ul className="space-y-3 text-white/60 text-sm">
              <li>
                <Link
                  to="/products/manhole-covers"
                  className="hover:text-[#f9d71c] transition-colors"
                >
                  Manhole Covers & Gratings
                </Link>
              </li>

              <li>
                <Link
                  to="/products/pipes-fittings"
                  className="hover:text-[#f9d71c] transition-colors"
                >
                  Ductile Pipes & Fittings
                </Link>
              </li>

              <li>
                <Link
                  to="/products/valves-fasteners"
                  className="hover:text-[#f9d71c] transition-colors"
                >
                  Valves & Fasteners
                </Link>
              </li>

              <li>
                <Link
                  to="/products/insulators"
                  className="hover:text-[#f9d71c] transition-colors"
                >
                  Electrical Insulators
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div className="md:justify-self-end text-left">
            <h4 className="font-semibold mb-4">Contact</h4>
            <ul className="space-y-3 text-white/60 text-sm max-w-xs">
              <li className="flex gap-2">
                <MapPin className="w-4 h-4 mt-0.5 text-[#f9d71c] shrink-0" />
                <span>
                  Plot No. 41, Door No.2, 3rd Cross Street, Brindhavan Nagar,
                  Valasaravakkam, Chennai - 600 087, India.
                </span>
              </li>

              <li className="flex gap-2 items-center">
                <Phone className="w-4 h-4 text-[#f9d71c] shrink-0" />
                <span>+91 44 4335 6128</span>
              </li>

              <li className="flex gap-2 items-center">
                <Mail className="w-4 h-4 text-[#f9d71c] shrink-0" />
                <span>sales@jasmineenterprises.in</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="border-t border-white/10 mt-12 pt-6 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-white/40 text-sm">
            © {new Date().getFullYear()} Jasmine Enterprises. All rights reserved.
          </p>
          <p className="text-white/40 text-sm">
            Product Marketing
          </p>
        </div>
      </div>
    </footer>
  );
}
